import React, { forwardRef } from 'react';
import type { DrawerRefMethods } from '@goodfynd/hooks';
import { useDrawerRef } from '@goodfynd/hooks';
import { Drawer, Text } from '@goodfynd/ui';
import { Button } from '@goodfynd/ui';

import { SubscriptionCheckout } from './SubscriptionCheckout';
import type { SubscriptionsCheckoutDrawerProps } from './types';

import classes from './SubscriptionsCheckout.module.css';

export const SubscriptionsCheckoutDrawer = forwardRef(
  function SubscriptionsCheckoutDrawer(
    { targetProps }: SubscriptionsCheckoutDrawerProps,
    ref: React.ForwardedRef<DrawerRefMethods | null>
  ) {
    const { close, isOpen, open } = useDrawerRef({
      ref,
    });

    return (
      <>
        <Button content="Checkout" onClick={open} {...targetProps} />

        <Drawer
          className={classes['checkout-drawer']}
          header={<Text as="pageTitle">Checkout</Text>}
          headerClass={classes['checkout-drawer-header']}
          onClose={() => close()}
          onOpen={() => open()}
          open={isOpen}
        >
          {isOpen && <SubscriptionCheckout />}
        </Drawer>
      </>
    );
  }
);
